import React from "react";
import {
    Layout,

    Menu
} from "antd";
import Brokers from "./Broker/Brokers";
import Agencys from "./Agencies/Agencies";
import Clients from "./Client/Clients";
import MiCompAPI from "../../util/api";
const { Content } = Layout;
class AllContracts extends React.Component {

    constructor(props) {

        super(props);
        this.state =
        {
            currentTab: 'brokers',

        }

        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount = () => {

    };

    handleClick = (e) => {
        this.setState({
            currentTab: e.key,
        });
    };

    getSelectedTabView() {
        switch (this.state.currentTab) {
            case "brokers":
                return <Brokers {...this.props} userPermandMasters={this.props.userPermandMasters} />
            case "agencys":
                return <Agencys {...this.props} userPermandMasters={this.props.userPermandMasters} />
            case "clients":
                return <Clients {...this.props} userPermandMasters={this.props.userPermandMasters} />
            default:
                return <></>;
        }
    }
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        return (
            <Content>

                <div className="mi_main_div">
                    {role === "bsu admin" ? <Menu className=".mi_general_bar" style={{width:'fit-content' }}
                        onClick={this.handleClick}
                        selectedKeys={[this.state.currentTab]}
                        mode="horizontal"                    >
                        <Menu.Item className="mi_menu_item" key="brokers">
                            Brokers
                        </Menu.Item>
                        <Menu.Item className="mi_menu_item" key="agencys" >
                            Agencies
                        </Menu.Item>
                        <Menu.Item className="mi_menu_item" key="clients" >
                            Clients
                        </Menu.Item>
                    </Menu> : (role === "carrier" ?
                        <Menu className="mi_general_bar" style={{width:'fit-content' }}
                            onClick={this.handleClick}
                            selectedKeys={[this.state.currentTab]}
                            mode="horizontal"                    >
                            <Menu.Item className="mi_menu_item" key="brokers">
                                Brokers
                            </Menu.Item>
                            <Menu.Item className="mi_menu_item" key="agencys" >
                                Agencies
                            </Menu.Item>

                        </Menu> : "")}

                    {this.getSelectedTabView()}
                </div>
            </Content>
        );
    }
}
export default AllContracts;
